import { GUID } from "@faro-lotv/foundation";
import { Quaternion, Vector3 } from "three";

export type ManualBlur = {
  /** Unique id for this manual blur */
  id: GUID;

  /** The world position of the blur*/
  position: Vector3;

  /** The world rotation of the blur */
  quaternion: Quaternion;

  /** The scale of the blur rectangle */
  scale: Vector3;
};

/**
 * Label for manual blur rectangles to be rendered. This is needed so that the rendering pipeline
 * can discriminate the manual blur rectangles from other renderable objects, and dispatch them
 * to the correct rendering pass.
 */
export const MANUAL_BLUR_LABEL = "Manual Blur";
